import { forEach } from "ramda";

const getItem = (storage, key) => {
  try {
    if (!storage)
      throw new Error(
        "Please pass a storage parameter (either localStorage or sessionStorage)"
      );
    const item = storage.getItem(key);
    return item ? JSON.parse(item) : undefined;
  } catch (error) {
    throw error;
  }
};

const setItem = (storage, key, value) => {
  try {
    if (!storage)
      throw new Error(
        "Please pass a storage parameter (either localStorage or sessionStorage)"
      );
    storage.setItem(key, JSON.stringify(value));
  } catch (error) {
    throw error;
  }
};

const deleteItems = (storage, keys) => {
  try {
    if (!storage)
      throw new Error(
        "Please pass a storage parameter (either localStorage or sessionStorage)"
      );
    if (!Array.isArray(keys))
      throw new Error("Please pass an array of keys to delete)");

    forEach(key => setItem(storage, key, null), keys);
  } catch (error) {
    throw error;
  }
};

const deleteItem = (storage, key) => deleteItems(storage, [key]);

const storageUtils = {
  deleteItem,
  deleteItems,
  getItem,
  setItem
};

export default storageUtils;
